import { Global } from './../../Service/global.service';
import { AnpEnChiffreService } from './../../Service/anp-en-chiffre.service';
import { HighContrastModeDetector } from '@angular/cdk/a11y';
import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as xml2js from 'xml2js';
declare var $ : any;
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-anpen-chiffres',
  templateUrl: './anpen-chiffres.component.html',
  styleUrls: ['./anpen-chiffres.component.scss']
})
export class ANPEnChiffresComponent implements OnInit {

Bloc1Title; Bloc1Description; Bloc2Title; Bloc2Description; Bloc3Title;Bloc3Description; Bloc4Title;Bloc4Description;
Table1Data : any = []; Table1Name; Table1Description : any = [] ;
Table2Data : any = []; Table2Name; Table2Resultats: any = [];
Table3Data : any = []; Table3Name; Table3Resultats: any = [];
Table4Data : any = []; Table4Name;
Table5Data : any = []; Table5Name;
Table6Data : any = []; Table6Name;
highCharts: typeof Highcharts= Highcharts;
chartOptions; chartOptions2;chartOptions3;chartOptions4;chartOptions5;chartOptions6;
pieloaded = false; pieloaded2 = false; pieloaded3 = false; pieloaded4 = false; barloaded1 = false; pieloaded5 = false;

  CreatePie1(ddata,Title,lg)
  {    
    this.chartOptions = {
        credits: {
            enabled: false
         },
          chart : {        
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            margin: [10, 150, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height:  250
         },
         legend: {    
              enabled: true,
              layout: 'vertical',
              verticalAlign: 'top',
              x: 100,
              y: 20, //chart.height/4
              labelFormatter:  function() {               
                return lg.toUpperCase() !=='AR' ? this.name +" "+ this.y +"%" : this.y +"%"+"  "+this.name;
              }
         },
         title: {
            text: Title,
            fontFamily: 'Prompt',
            align: lg.toUpperCase() !=='AR' ? "left":"right",
            useHTML: true,
            style: {
              textTransform: "uppercase",
              fontSize: lg.toUpperCase() !=='AR' ? "12px":"15px",
              fontWeight: '600'
            }
          },
         tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
         accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
         plotOptions : {           
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                innerSize: '38%',
                colors: ddata[1],
                dataLabels: {
                  enabled: true,
                  inside : true,
                  color: 'white',
                  distance: -30,
                  formatter: function() {
                    return Math.round(this.percentage) + ' %';
                }
                },
                showInLegend: true
              }
         },
         series: [{
            colorByPoint: true,
            data: ddata[0]
          }],
          exporting: {
            enabled: false
          }
      };
           this.pieloaded =true;
  }
  CreatePie2(ddata,Title,lg)
  {      
    this.chartOptions2 = {
        credits: {
            enabled: false
         },
          chart : {        
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            margin: [10, 150, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height:  250
         },
         legend: {    
              enabled: true,
              layout: 'vertical',
              verticalAlign: 'top',
              x: 100,
              y: 20, //chart.height/4
              labelFormatter:  function() {               
                return lg.toUpperCase() !=='AR' ? this.name +" "+ this.y +"%" : this.y +"%"+"  "+this.name;
              }
         },
         title: {
            text: Title,
            fontFamily: 'Prompt',
            align: lg.toUpperCase() !=='AR' ? "left":"right",
            useHTML: true,
            style: {
              textTransform: "uppercase",
              fontSize: lg.toUpperCase() !=='AR' ? "12px":"15px",
              fontWeight: '600'
            }
          },
         tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
         accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
         plotOptions : {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                innerSize: '38%',
                colors: ddata[1],
                dataLabels: {
                  enabled: true,
                  inside : true,
                  color: 'white',
                  distance: -30,
                  formatter: function() {
                    return Math.round(this.percentage) + ' %';
                  }
                },
                showInLegend: true
              }
         },
         series: [{
            colorByPoint: true,
            data: ddata[0]
          }],
          exporting: {
            enabled: false
          }
      };
      this.pieloaded2 =true;
  }
  CreatePie3(ddata,Title,lg)
  {     
    this.chartOptions3 = {
        credits: {
            enabled: false
         },
          chart : {        
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            margin: [10, 150, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height:  250
         },
         legend: {    
              enabled: true,
              layout: 'vertical',
              verticalAlign: 'top',
              x: 100,
              y: 20, //chart.height/4
              labelFormatter:  function() {               
                return lg.toUpperCase() !=='AR' ? this.name +" "+ this.y +"%" : this.y +"%"+"  "+this.name;
              }
         },
         title: {
            text: Title,
            fontFamily: 'Prompt',
            align: lg.toUpperCase() !=='AR' ? "left":"right",
            useHTML: true,
            style: {
              textTransform: "uppercase",
              fontSize: lg.toUpperCase() !=='AR' ? "12px":"15px",
              fontWeight: '600'
            }
          },
         tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
         accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
         plotOptions : {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                innerSize: '38%',
                colors: ddata[1],
                dataLabels: {
                  enabled: true,
                  inside : true,
                  color: 'white',
                  distance: -30,
                  formatter: function() {
                    return Math.round(this.percentage) + ' %';
                  }
                },
                showInLegend: true
              }
         },
         series: [{
            colorByPoint: true,
            data: ddata[0]
          }],
          exporting: {
            enabled: false
          }
      };
      this.pieloaded3 =true;
  }
  CreatePie4(ddata,Title,lg)
  { 
    this.chartOptions4 = {
        credits: {
            enabled: false
         },
          chart : {        
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            margin: [10, 250, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height:  350
         },
         legend: {    
              enabled: true,
              layout: 'vertical',
              verticalAlign: 'top',
              x: 140,
              y: 20, //chart.height/4
              labelFormatter:  function() {               
                return lg.toUpperCase() !=='AR' ? this.name +" "+ this.y +"%" : this.y +"%"+"  "+this.name;
              }
         },
         title: {
            text: Title,
            fontFamily: 'Prompt',
            align: lg.toUpperCase() !=='AR' ? "left":"right",
            useHTML: true,
            style: {
              textTransform: "uppercase",
              fontSize: lg.toUpperCase() !=='AR' ? "12px":"15px",
              fontWeight: '600'
            }
          },
         tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
         accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
         plotOptions : {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                innerSize: '38%',
                colors: ddata[1],
                dataLabels: {
                  enabled: true,
                  inside : true,
                  color: 'white',
                  distance: -30,
                  formatter: function() {
                    return Math.round(this.percentage) + ' %';
                  }
                },
                showInLegend: true
              }
         },
         series: [{
            colorByPoint: true,
            data: ddata[0]
          }],
          exporting: {
            enabled: false
          }
      };
      this.pieloaded4 =true;
  }
  CreateBar1(ddata,Title,yAxis,lg)
  { 
    this.chartOptions5 = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'column',
      height:  250
    },
    title: {
      text: Title,
      fontFamily: 'Prompt',
      align: lg.toUpperCase() !=='AR' ? "left":"right",
      useHTML: true,
      style: {
        textTransform: "uppercase",
        //fontSize: "12px", 
        fontSize: lg.toUpperCase() !=='AR' ? "12px":"15px",
        fontWeight: '600'
      }
    },

    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: yAxis
      }

    },
    legend: {
      enabled: false
    },
    plotOptions: {

      series: {

        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          inside: true,
          verticalAlign: 'top',
          shadow: false
        }
      }
    },

    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>'
    },

    series: [
      {
        name: "Chiffre d'affaires",
        colorByPoint: false,
        color: '#139FD8',
        data: ddata
      }
    ],
    exporting: {
      enabled: false
    }
    };
    this.barloaded1 =true;
  }
  CreatePie5(ddata,Title,lg)
  {   
    this.chartOptions6 = {
        credits: {
            enabled: false
         },
          chart : {        
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            margin: [10, 250, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height:  250
         },
         legend: {    
              enabled: true,
              layout: 'vertical',
              verticalAlign: 'top',
              x: 100,
              y: 20, //chart.height/4
              labelFormatter:  function() {               
                return lg.toUpperCase() !=='AR' ? this.name +" "+ this.y +"%" : this.y +"%"+"  "+this.name;
              }
         },
         title: {
            text: Title,
            fontFamily: 'Prompt',
            align: lg.toUpperCase() !=='AR' ? "left":"right",
            useHTML: true,
            style: {
              textTransform: "uppercase",
              fontSize: lg.toUpperCase() !=='AR' ? "12px":"15px",
              fontWeight: '600'
            }
          },
         tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
         accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
         plotOptions : {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                innerSize: '38%',
                colors: ddata[1],
                dataLabels: {
                  enabled: true,
                  inside : true,
                  color: 'white',
                  distance: -30,
                  formatter: function() {
                    return Math.round(this.percentage) + ' %';
                  }
                },
                showInLegend: true
              }
         },
         series: [{
            colorByPoint: true,
            data: ddata[0]
          }],
          exporting: {
            enabled: false
          }
      };
      this.pieloaded5 =true;
  }
  parseXMLGraph(data) {  
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [[],[],[]],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.elements;  
        for (k in obj.element) {  
          var item = obj.element[k];  
          arr[0].push({    
            name: item.legend[0],  
            y: parseFloat(item.valeur[0].replace(",",".")) 
          });
          if(item.couleur)
          {
            arr[1].push(item.couleur[0]);
          }
        } 
        for (item in obj.yAxis) {           
            arr[2].push(obj.yAxis[item]);
        }
        resolve(arr);  
      });  
    });  
  }  
  parseXMLTableData(data) {  
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [[],[]],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.elements;  
        for (k in obj.element) {  
          var item = obj.element[k];  
          arr[0].push({    
            titre: item.titre[0],  
            valeur: item.valeur[0],
            unit: item.unit[0],
          });
        } 
        for (k in obj.description) {  
          var item = obj.description[k]; 
            arr[1].push(item);
        }   
        resolve(arr);  
      });  
    });  
  } 
  parseXMLTable(data) {  
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [[],[]],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.table;  
        for (k in obj.tr) {  
          var item = obj.tr[k]; 
          if(item.resultat)
          {
              arr[1].push({   
                Titre: item.resultat[0],
                Valeur: item.resultat[1]
              });          
          }
          else
          {
            arr[0].push({   
              Titre: item.td?item.td[0].replace('-B-','<b/>'):(item.th?item.th[0]:(item.result?item.result[0]:"")),
              Valeur: item.td?item.td[1]:(item.th?item.th[1]:(item.result?item.result[1]:""))
            });          
          }
        }
        resolve(arr);  
      });  
    });  
  }
  constructor(private service:AnpEnChiffreService, private global:Global) { }
  ngOnInit() { 
    //#region variables 
    this.Table1Data = []
    this.Table1Name = ""
    this.Table2Data = []
    this.Table2Name = ""
    this.Table3Data = []
    this.Table3Name = ""
    this.Table4Data = []
    this.Table4Name = ""
    this.Table5Data = []
    this.Table5Name = ""
    this.Table6Data = []
    this.Table6Name = ""
    let Title;
    //#endregion
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      //#region Bloc1
      this.service.getGhaphData(lg,"Bloc1").subscribe(datas=> {
            this.Bloc1Title = datas['value'][0].Title;
            this.Bloc1Description = datas['value'][0].Contenu;        
      });       
      this.service.getGhaphData(lg,"Pie1").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLGraph(datas['value'][0].Contenu)  
          .then((data) => {            
            Title = datas['value'][0].Title;
            this.CreatePie1(data,Title,lg["code"]);
          });  
      }); 
      this.service.getGhaphData(lg,"Pie2").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLGraph(datas['value'][0].Contenu)  
          .then((data) => {            
            Title = datas['value'][0].Title;            
            this.CreatePie2(data,Title,lg["code"]);
          });  
      }); 
      this.service.getGhaphData(lg,"Pie3").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLGraph(datas['value'][0].Contenu)  
          .then((data) => {            
            Title = datas['value'][0].Title;
            this.CreatePie3(data,Title,lg["code"]);
          });  
      }); 
      this.service.getGhaphData(lg,"Table1").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLTableData(datas['value'][0].Contenu)  
          .then((data) => {            
            this.Table1Name = datas['value'][0].Title;
            this.Table1Data = data[0];
            this.Table1Description = data[1];
          });     
      });
      //#endregion
      //#region Bloc2
      this.service.getGhaphData(lg,"Bloc2").subscribe(datas=> {
        this.Bloc2Title = datas['value'][0].Title;
        this.Bloc2Description = datas['value'][0].Contenu;        
      }); 
      this.service.getGhaphData(lg,"Pie4").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLGraph(datas['value'][0].Contenu)  
          .then((data) => {            
            Title = datas['value'][0].Title;
            this.CreatePie4(data,Title,lg["code"]);
          });  
      });

      this.service.getGhaphData(lg,"Table2").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLTable(datas['value'][0].Contenu)  
          .then((data) => {
            this.Table2Name = datas['value'][0].Title;
            this.Table2Data = data[0];
            this.Table2Resultats = data[1];
          });  
      });
      //#endregion
      //#region Bloc3
      this.service.getGhaphData(lg,"Bloc3").subscribe(datas=> {
        this.Bloc3Title = datas['value'][0].Title;
        this.Bloc3Description = datas['value'][0].Contenu;        
      }); 
      this.service.getGhaphData(lg,"Bar1").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLGraph(datas['value'][0].Contenu)  
          .then((data) => {            
            Title = datas['value'][0].Title;
            this.CreateBar1(data[0],Title,data[2][0],lg["code"]);
          });  
      });
      this.service.getGhaphData(lg,"Pie5").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLGraph(datas['value'][0].Contenu)  
          .then((data) => {            
            Title = datas['value'][0].Title;
            this.CreatePie5(data,Title,lg["code"]);
          });  
      });
      //#endregion
      //#region Bloc 4
      this.service.getGhaphData(lg,"Bloc4").subscribe(datas=> {
        this.Bloc4Title = datas['value'][0].Title;
        this.Bloc4Description = datas['value'][0].Contenu;        
      }); 
      this.service.getGhaphData(lg,"Table3").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLTable(datas['value'][0].Contenu)  
          .then((data) => {
            this.Table3Name = datas['value'][0].Title;
            this.Table3Data = data[0];
            this.Table3Resultats = data[1];
          });  
      }); 
      this.service.getGhaphData(lg,"Table4").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLTable(datas['value'][0].Contenu)  
          .then((data) => {  
            this.Table4Name = datas['value'][0].Title;
            this.Table4Data = data[0];
          });  
      });  
      this.service.getGhaphData(lg,"Table5").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLTable(datas['value'][0].Contenu)  
          .then((data) => {  
            this.Table5Name = datas['value'][0].Title;
            this.Table5Data = data[0];
          });  
      });  
      this.service.getGhaphData(lg,"Table6").subscribe(datas=> {
        const p: xml2js.Parser = new xml2js.Parser();
        this.parseXMLTable(datas['value'][0].Contenu)  
          .then((data) => {  
            this.Table6Name = datas['value'][0].Title;
            this.Table6Data = data[0];
          });  
      });
      //#endregion   
    }) 
  }
}
